export type StatusId = "poison" | "burn" | "freeze" | "slow";
export interface Status {
  id: StatusId;
  remaining: number;
  tick: number;
  potency: number;
}
export interface StatusActor {
  health: number;
  statuses?: Status[];
  boss?: unknown;
}
export const STATUS_RULES: Record<
  StatusId,
  { name: string; duration: number; potency: number; color: string }
> = {
  poison: { name: "中毒", duration: 4, potency: 3, color: "#b9c96e" },
  burn: { name: "燃烧", duration: 3, potency: 4, color: "#f0a46e" },
  freeze: { name: "冰冻", duration: 1.1, potency: 1, color: "#a5dce1" },
  slow: { name: "减速", duration: 3, potency: 0.3, color: "#b1c9e9" },
};
export function applyStatus(
  actor: StatusActor,
  id: StatusId,
  duration = STATUS_RULES[id].duration,
  potency = STATUS_RULES[id].potency,
) {
  if (actor.health <= 0) return;
  const statuses = (actor.statuses ??= []);
  if (id === "burn")
    actor.statuses = actor.statuses?.filter((s) => s.id !== "freeze");
  if (id === "freeze" && statuses.some((s) => s.id === "burn")) {
    actor.statuses = statuses.filter((s) => s.id !== "burn");
    id = "slow";
    duration = 1.5;
    potency = 0.35;
  }
  if (id === "freeze" && actor.boss) {
    id = "slow";
    duration = 1.3;
    potency = 0.35;
  }
  actor.statuses ??= [];
  const old = actor.statuses.find((s) => s.id === id);
  if (old) {
    old.remaining = Math.max(old.remaining, duration);
    old.potency = Math.max(old.potency, potency);
  } else actor.statuses.push({ id, remaining: duration, potency, tick: 0 });
}
export function cleanse(actor: StatusActor) {
  actor.statuses = [];
}
export function statusSpeed(actor: StatusActor) {
  if (actor.statuses?.some((s) => s.id === "freeze")) return 0;
  return (
    1 -
    Math.max(
      0,
      ...(actor.statuses ?? [])
        .filter((s) => s.id === "slow")
        .map((s) => Math.min(0.45, s.potency)),
    )
  );
}
export function tickStatuses(
  actor: StatusActor,
  dt: number,
  damage: (n: number) => void,
) {
  if (actor.health <= 0) {
    actor.statuses = [];
    return;
  }
  for (const s of actor.statuses ?? []) {
    const elapsed = Math.min(s.remaining, dt);
    s.remaining -= dt;
    s.tick += elapsed;
    if (s.id === "poison" || s.id === "burn")
      while (s.tick + 1e-9 >= 1) {
        s.tick = Math.max(0, s.tick - 1);
        damage(s.potency);
        if (actor.health <= 0) break;
      }
  }
  actor.statuses = actor.statuses?.filter((s) => s.remaining > 1e-9);
}
